import { Col } from '@landsbankinn/ui-kit';
import { type ReactNode } from 'react';
import {
  MAX_WIDTH as headerWidth,
  SimpleHeader,
} from 'src/components/Layout/Desktop/Header/SimpleHeader';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { useApplicationClientContext } from '../../../state';
import type { LoginBoxRef } from '../Layout';

export function LandsbankinnOnlineBank(props: {
  children?: ReactNode;
  loginBoxRef?: LoginBoxRef;
}) {
  const [clientState] = useApplicationClientContext();
  const { isMobile } = useScreenSize();
  return (
    <Col
      color="blue font"
      background="blue baseLight"
      crossAxisAlignment="center"
      minHeight="100vh"
      paddingHorizontal={isMobile ? '36' : '0'}
    >
      <SimpleHeader />
      <Col
        ref={props.loginBoxRef}
        maxWidth={headerWidth}
        paddingHorizontal="20"
        width="100%"
        marginTop="56"
        grow="1"
        height={clientState.isSubmitting ? '642px' : 'auto'}
      >
        {props.children}
      </Col>
    </Col>
  );
}
